










import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import { ServerResult } from '@/core/http/server_result';
import { QueryBuilder } from '@/core/uql';

@Component
export default class DecimalComponent extends Vue {
  $db!: (queries: any[]) => Promise<ServerResult>
  $q!: (queryName: string) => QueryBuilder;

  @Prop() value!: any;
  @Prop({ type: String }) label!: string;
  @Prop({ type: String }) type!: any[];
  @Prop({ type: String }) placeholder!: string;

  localValue: any = null

  @Watch('value')
  onValueChange(newVal: any) {
    this.localValue = newVal;
  }

  updateValue(value: any) {
    value = parseFloat(value.replace(',', '.'))
    this.onValueChange(value);

    this.$emit('input', value);
  }
}
